import { Service } from '@angular/core';

/**
 * Latch around the 401 teardown. A page typically has several requests in flight,
 * so without it every one of them clears storage, raises a snackbar and starts a
 * competing navigation to the login page.
 */
@Service()
export class SessionExpiryService {
  private isHandlingUnauthorized = false;

  /** True for the first caller only, until {@link reset} runs. */
  claimUnauthorizedHandling(): boolean {
    if (this.isHandlingUnauthorized) {
      return false;
    }

    this.isHandlingUnauthorized = true;

    return true;
  }

  reset(): void {
    this.isHandlingUnauthorized = false;
  }
}
